interface ZoomControlsProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
  minZoom?: number;
  maxZoom?: number;
}

export function ZoomControls({
  zoom,
  onZoomIn,
  onZoomOut,
  onReset,
  minZoom = 0.5,
  maxZoom = 3,
}: ZoomControlsProps) {
  return (
    <div className="flex items-center gap-1 bg-black/60 backdrop-blur-sm rounded-lg px-2 py-1.5 shadow-lg">
      <button
        type="button"
        onClick={onZoomOut}
        disabled={zoom <= minZoom}
        className="p-1.5 rounded text-white hover:bg-white/20 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        title="Verkleinern (Ctrl + Scroll)"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
        </svg>
      </button>

      <button
        type="button"
        onClick={onReset}
        className="px-2 py-1 text-sm font-medium text-white hover:bg-white/20 rounded min-w-[52px] transition-colors"
        title="Zoom zurücksetzen"
      >
        {Math.round(zoom * 100)}%
      </button>

      <button
        type="button"
        onClick={onZoomIn}
        disabled={zoom >= maxZoom}
        className="p-1.5 rounded text-white hover:bg-white/20 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        title="Vergrößern (Ctrl + Scroll)"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
      </button>
    </div>
  );
}
